export default __webpack_public_path__ + "static/media/7.1Vid.bfb3043a.mp4";